import { FlexComponent } from "src/typings/flexFramework/FlexComponent";

export interface LobNavigationProps {
  lobs: FlexComponent[];
}

export interface LobNavigationItemProps extends NavigationItemProps {
  flexComponent: FlexComponent;
  index: number;
  lobsLength: number;
}

export interface LobNavigationItemsProps extends NavigationItemProps {
  lobs: FlexComponent[];
}

interface NavigationItemProps {
  searchParams: string;
  getLabel(lobName: string): string;
  isTabChecked(lobName: string): boolean;
  getLobIcon(lobName: string): string;
  handleLobChange(lobName: string, model: any): () => void;
}

export enum scrimValues {
  EMPTY = "",
  LEFT = "left",
  RIGHT = "right",
  BOTH = "both",
}

export interface LobNavigationScrimsProps {
  scrimsToDisplay: scrimValues;
}
